import React from "react";
import { ToastContainer } from "react-toastify";
import ViewTag from "../../components/ProductManager/Tag/ViewTag";

export const ViewTagPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ViewTag />
        </div>
      </div>
    </div>
  );
};
